"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactBootstrapTypeahead = require("react-bootstrap-typeahead");
var _react = require("react");
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
const TypeAhead = ({
  align,
  allowNew,
  autoFocus,
  caseSensitive,
  clearButton,
  defaultInputValue,
  defaultOpen,
  defaultSelected,
  disabled,
  dropup,
  emptyLabel,
  error,
  errorMsg,
  filterBy,
  flip,
  highlightOnlyResult,
  hint,
  id,
  ignoreDiacritics,
  inputProps,
  isInvalid,
  isLoading,
  isValid,
  label,
  labelKey,
  maxHeight,
  maxItems,
  onChange,
  onInputChange,
  onBlur,
  onFocus,
  onKeyDown,
  onMenuToggle,
  onPaginate,
  onSearch,
  open,
  options,
  optionalText,
  paginate,
  paginationText,
  placeholder,
  positionFixed,
  readOnly,
  renderInput,
  renderMenu,
  renderMenuItemChildren,
  renderToken,
  selected,
  selectHint,
  setFocus,
  size,
  showAsCombobox,
  ...props
}) => {
  const typeahead = (0, _react.useRef)();
  const menuItemHeight = 52;
  var menuContainerHeight = maxHeight || 312;
  var maxResults = 100;
  var customPaginate = true;
  (0, _react.useEffect)(() => {
    var _typeahead$current;
    if (setFocus) (_typeahead$current = typeahead.current) == null || _typeahead$current.focus();
  }, []);
  if (showAsCombobox && maxItems) {
    menuContainerHeight = menuItemHeight * maxItems + 'px';
  } else if (!showAsCombobox && maxItems) {
    maxResults = maxItems;
    customPaginate = false;
    menuContainerHeight = menuItemHeight * maxItems + 'px';
  } else {
    menuContainerHeight = menuItemHeight * 6 + 'px';
  }
  if (!props.multiple) props.minLength = 1;
  const cssComponentClass = 'ccl__form-typeahead';
  const cssTextClass = 'ccl__text';
  const customRenderInput = ({
    inputRef,
    referenceElementRef,
    ...inputProps
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: [`${cssComponentClass}--container`].join(' '),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ...inputProps,
      className: [`${cssComponentClass}--is-input`].join(' '),
      readOnly: readOnly,
      ref: node => {
        inputRef(node);
        referenceElementRef(node);
      }
    })
  });
  const ToggleButton = ({
    onClick
  }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: `${cssComponentClass}--is-line`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      className: `${cssComponentClass}--is-icon`,
      type: "expand-more",
      onClick: onClick,
      onMouseDown: e => {
        // Prevent input from losing focus.
        e.preventDefault();
      }
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: [cssComponentClass, `${cssComponentClass}--is-form-input`, size && `${cssComponentClass}--is-${size}`, error ? `${cssComponentClass}--has-error` : '', disabled ? `${cssComponentClass}--is-disabled` : '', readOnly ? `${cssComponentClass}--is-read-only` : '', showAsCombobox && `${cssComponentClass}--is-combobox`, props.multiple && `${cssComponentClass}--is-multiple`, props.className || ''].join(' '),
      ...props,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
        className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold`,
        htmlFor: id || props.name,
        children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: `${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`,
          children: `(${optionalText})`
        })]
      }), hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: `${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`,
        children: hint
      }), !props.async && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBootstrapTypeahead.Typeahead, {
        align: align,
        allowNew: allowNew,
        autoFocus: autoFocus,
        caseSensitive: caseSensitive,
        clearButton: clearButton,
        defaultInputValue: defaultInputValue,
        defaultOpen: defaultOpen,
        defaultSelected: defaultSelected,
        disabled: disabled,
        dropup: dropup,
        emptyLabel: emptyLabel,
        filterBy: filterBy,
        flip: flip,
        highlightOnlyResult: highlightOnlyResult,
        ignoreDiacritics: ignoreDiacritics,
        inputProps: inputProps,
        isInvalid: isInvalid,
        isLoading: isLoading,
        isValid: isValid,
        labelKey: labelKey,
        maxResults: maxResults,
        onChange: onChange,
        onInputChange: onInputChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMenuToggle: onMenuToggle,
        onPaginate: onPaginate,
        onSearch: onSearch,
        open: open,
        paginate: paginate || customPaginate,
        paginationText: paginationText,
        positionFixed: positionFixed,
        renderMenu: renderMenu,
        renderMenuItemChildren: renderMenuItemChildren,
        renderToken: renderToken,
        selected: selected,
        selectHint: selectHint,
        size: size,
        id: id,
        ref: typeahead,
        maxHeight: menuContainerHeight,
        renderInput: props.multiple ? renderInput : customRenderInput,
        placeholder: placeholder,
        options: options,
        ...props,
        children: ({
          isMenuShown,
          toggleMenu
        }) => showAsCombobox && /*#__PURE__*/(0, _jsxRuntime.jsx)(ToggleButton, {
          onClick: e => {
            toggleMenu();
          }
        })
      }), props.async && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBootstrapTypeahead.AsyncTypeahead, {
        id: id,
        ref: typeahead,
        align: align,
        allowNew: allowNew,
        autoFocus: autoFocus,
        caseSensitive: caseSensitive,
        clearButton: clearButton,
        defaultInputValue: defaultInputValue,
        defaultOpen: defaultOpen,
        defaultSelected: defaultSelected,
        disabled: disabled,
        dropup: dropup,
        emptyLabel: emptyLabel,
        filterBy: filterBy,
        flip: flip,
        highlightOnlyResult: highlightOnlyResult,
        ignoreDiacritics: ignoreDiacritics,
        inputProps: inputProps,
        isInvalid: isInvalid,
        isLoading: isLoading,
        isValid: isValid,
        labelKey: labelKey,
        maxResults: maxResults,
        onChange: onChange,
        onInputChange: onInputChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMenuToggle: onMenuToggle,
        onPaginate: onPaginate,
        onSearch: onSearch,
        open: open,
        paginate: paginate || customPaginate,
        paginationText: paginationText,
        positionFixed: positionFixed,
        renderMenu: renderMenu,
        renderMenuItemChildren: renderMenuItemChildren,
        renderToken: renderToken,
        selected: selected,
        selectHint: selectHint,
        size: size,
        maxHeight: menuContainerHeight,
        renderInput: props.multiple ? renderInput : customRenderInput,
        placeholder: placeholder,
        options: options,
        ...props
      }), error && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          color: "error",
          type: "error",
          size: "xs"
        }), errorMsg]
      })]
    })
  });
};
TypeAhead.defaultProps = {
  emptyLabel: 'No matching option',
  placeholder: 'start typing...',
  id: 'typeahead'
};
var _default = exports.default = TypeAhead;
module.exports = exports.default;